import {Typography} from "@mui/material"
import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/themes"
import {
    HORIZONTAL_FILTERS_ITEM_COUNT_WIDTH,
    ALL_FILTERS_MOBILE_HORIZONTAL_FILTERS_ITEM_COUNT_WIDTH,
} from "../../../../config/constants"

// Horizontal Filter Styling

interface HFStyledHeaderProps {
    breadcrumbsEnabled: boolean
    isMerchandisedUrl: boolean
}

export const HFStyledClearAllContainer = styled("div")`
    display: flex;
    flex-grow: 1;
    flex: 1 0 80%;
    justify-content: flex-end;
    padding-bottom: 1.5rem;
    padding-left: 0.5rem;
    padding-right: 0.5rem;

    @media (min-width: ${breakpoints.values.md}px) {
        padding-left: 1rem;
        padding-right: 1rem;
    }

    @media (min-width: ${breakpoints.values.lg}px) {
        flex: 1 0 75%;
    }

    @media (min-width: ${breakpoints.values.xl}px) {
        flex: 1 0 80%;
    }

    @media (max-width: ${breakpoints.values.lg - 1}px) {
        display: none;
    }
`

export const HFStyledHeader = styled("header")<HFStyledHeaderProps>`
    flex-grow: 1;
    flex: 1 0 80%;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    position: sticky;
    top: calc(
        var(--next-header-lg-height, 6.5625rem)
            ${({breadcrumbsEnabled, isMerchandisedUrl}) =>
                breadcrumbsEnabled && isMerchandisedUrl ? " + var(--next-plp-breadcrumbs-height)" : ""} + 70px
    );
    z-index: 4;
    @media (min-width: ${breakpoints.values.md}px) {
        padding-left: 1rem;
        padding-right: 1rem;
    }
    @media (min-width: ${breakpoints.values.lg}px) {
        flex: 1 0 75%;
    }
    @media (min-width: ${breakpoints.values.xl}px) {
        flex: 1 0 80%;
    }
    @media (max-width: ${breakpoints.values.lg - 1}px) {
        display: none;
    }
`

export const StyledNavList = styled("div")`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(calc(${HORIZONTAL_FILTERS_ITEM_COUNT_WIDTH}% - 1px), 1fr));
    @media (min-width: ${breakpoints.values.lg}px) {
        grid-template-columns: repeat(
            auto-fill,
            minmax(calc(${ALL_FILTERS_MOBILE_HORIZONTAL_FILTERS_ITEM_COUNT_WIDTH}% - 1px), 1fr)
        );
    }
    grid-gap: 1px;
    box-sizing: border-box;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(calc(${HORIZONTAL_FILTERS_ITEM_COUNT_WIDTH}% - 1px), 1fr));
    @media (min-width: ${breakpoints.values.lg}px) {
        grid-template-columns: repeat(
            auto-fill,
            minmax(calc(${ALL_FILTERS_MOBILE_HORIZONTAL_FILTERS_ITEM_COUNT_WIDTH}% - 1px), 1fr)
        );
    }
    grid-gap: 1px;
    box-sizing: border-box;
    outline: ${({theme}) => theme.colours.form.default.border};
    outline-color: ${({theme}) => theme.colours.other.ratingInactive};
    background-color: white;
`

export const StyledNavItem = styled("div")`
    outline: ${({theme}) => theme.colours.form.default.border};
    outline-color: ${({theme}) => theme.colours.other.ratingInactive};
    box-sizing: border-box;
    padding: 0;
    height: 2.75rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    text-transform: capitalize;
`
export const StyledNavItemSecondRow = styled("div")`
    outline: ${({theme}) => theme.colours.form.default.border};
    outline-color: ${({theme}) => theme.colours.other.ratingInactive};
    box-sizing: border-box;
    padding: 0;
    height: 2.75rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    text-transform: capitalize;
`

export const FeatNav = styled(StyledNavItem)`
    flex-grow: unset;
`

export const StyledMoreLessItem = styled(StyledNavItem)`
    cursor: pointer;
`

export const MoreLessLabel = styled(Typography)`
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${({theme}) => theme.colours.form.buttonPrimary.background};
    font-weight: bold;
`

export const StyledNav = styled("nav")``

type TotalRowProps = {
    totalRows: number
}

export const StyledNavListSecondRow = styled("div")<TotalRowProps>`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(calc(25% - 1px), 1fr));
    @media (min-width: ${breakpoints.values.lg}px) {
        grid-template-columns: repeat(auto-fill, minmax(calc(16.6666% - 1px), 1fr));
    }
    grid-gap: 1px;
    height: ${props => `calc(${props.totalRows} * 44px + 1px)`};
    margin-top: 1px;
`
